import Button from "../../../../components/Button/Button";
import { Section, Card, FieldGrid, Field } from "./accountParts";

const AccountSettingsCard = ({ settings, canEdit, onEdit }) => {
  const currencyLabel = settings?.system_currency
    ? `${settings.system_currency.code} - ${settings.system_currency.name}`
    : null;

  return (
    <Section
      title="Account Settings"
      actions={
        canEdit && (
          <Button size="sm" onClick={onEdit}>
            Update
          </Button>
        )
      }
    >
      <Card>
        <FieldGrid>
          <Field label="System currency" value={currencyLabel} />
          <Field
            label="Time zone for new clients"
            value={settings?.default_client_timezone}
          />
          <Field
            label="Default quote PDF template"
            value={settings?.default_quote_template}
          />
          <Field
            label="Default client invoice PDF template"
            value={settings?.default_client_invoice_template}
          />
        </FieldGrid>
      </Card>
    </Section>
  );
};

export default AccountSettingsCard;
